<template>
    <div style="margin:0 10px">
        <router-view></router-view> 
        <div class="card">
            <!-- search -->
            <div class="search d-flex a-center">
                
                <div style="width:160px;margin-right:10px;">
                    <el-input type="text" v-model="query.keyword" placeholder="姓名、身份证"></el-input>  
                </div>
                <el-button type="primary" @click="init">查询</el-button>
                <el-button type="primary" @click="$router.push({name:'user_manager_create'})">+ 添加</el-button>
            </div>

            <!-- handle -->
            <div class="handle"></div>

            <!-- table -->
            <div class="table" style="margin-top:20px;">
                <el-table
                    :data="tableData"
                    style="width: 100%;"
                    v-loading="loading"
                    element-loading-background="rgba(255,255,255, 0.6)"
                    :header-cell-style="{background:'#f8f8f9',color:'#606266',borderBottom:'1px solid #e8eaec',padding:'8px 0',fontWeight:'700'}"
                >
                    <el-table-column prop="username" label="用户名" align="center"></el-table-column>
                    <el-table-column prop="name" label="真实姓名" align="center"></el-table-column>
                    <el-table-column prop="phone" label="手机号码" align="center"></el-table-column>
                    <el-table-column prop="" label="操作" align="center" width="180">
                        <template slot-scope="scope">
                            <el-button @click="$router.push({name:'user_manager_update',query:{id:scope.row.id}})" type="text" size="small">编辑</el-button>
                            <el-popconfirm
                                style="margin-left: 10px;"
                                title="是否确定删除？"
                                @confirm="handleDel(scope.row)"
                            >
                                <el-button type="text" slot="reference" size="small">删除</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- page -->
                <div style="margin-top:20px;text-align:center">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :total="total"
                        :page-sizes="pageSizes"
                        :page-size="query.size"
                        @size-change="onSize"
                        @current-change="onCurrPage"
                        @prev-click="onCurrPage"
                        @next-click="onCurrPage"
                    >
                    </el-pagination>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {lists,del} from '@/request/api/user_manager.js'
export default {
    data(){
        return {
            tableData: [],
            query:{keyword:'',page:1,size:10},
            pageSizes:[10,30,50,100],
            total:0 , //列表总数
            loading:false,
            isEdit:false ,//编辑状态
        }
    },
    watch:{
        $route(val ,old){
            //返回刷新
            if(val.name=='user_manager') {
                this.init()
            }
        }
    },

    created(){
        this.init()
    },

    methods:{
        init(){
            lists(this.query).then(res=>{
                this.tableData = res.data.list
                this.total = res.data.total
                this.query.page = res.data.currentPage
                this.query.limit = res.data.size
            })
        },

         //删除
         handleDel(data){
            del({ids:[data.id]}).then(res=>{
                if(res.code!=0) return this.$notify.error({title:'错误',message: res.msg});
                this.init()
                this.$notify({title: '成功',message: res.msg,type: 'success'});
            })
        },

        //每页条数
        onSize(val){
            this.query.size=val
            this.init()
        },
        onCurrPage(val){
            this.query.page = val
            this.init()
        }
    }
}
</script>


<style scoped lang="less">
.card {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;
}

</style>

